// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import { localize } from 'i18n-calypso'

// Internal Dependencies:
import Editable from 'church-theme-library/components/Editable/Editable'
import { templateReplace } from 'church-theme-library/utilities/templateReplace'
import Map from 'church-theme-library/components/Map/Map'
import MapMarker from 'church-theme-library/components/Map/MapMarker'

class EventDetails extends React.Component {
	render() {
		const { translate, page, userCanEditPage } = this.props

		if ( ! page || ! page.is_event ) {
			return null
		}

		// Date:
		let recurText,
			eventDate,
			eventStartDate,
			eventEndDate,
			eventHour,
			eventStartHour,
			eventEndHour

		if ( page.recur_text ) {
			recurText = page.recur_text
		}

		if ( page.start_time && page.start_time.raw ) {
			let { format_order } = page.date

			eventStartDate = templateReplace( format_order, page.start_time.rendered )
		}

		if ( page.end_time && page.end_time.raw ) {
			let { format_order } = page.date

			eventEndDate = templateReplace( format_order, page.end_time.rendered )
		}

		if ( eventEndDate ) {
			eventDate = translate( '%(eventStartDate)s to %(eventEndDate)s', {
				args: {
					eventStartDate: eventStartDate,
					eventEndDate: eventEndDate
				}
			} )
		} else {
			eventDate = eventStartDate
		}

		if ( page.start_time_hour && page.start_time_hour.rendered && page.end_time_hour.rendered ) {
			eventHour = translate( '%(eventStartTime)s till %(eventEndTime)s', {
				args: {
					eventStartTime: page.start_time_hour.rendered,
					eventEndTime: page.end_time_hour.rendered
				}
			} )
		} else if ( page.start_time_hour && page.start_time_hour.rendered ) {
			eventHour = page.start_time_hour.rendered
		}

		// Map:
		let mapCenter

		if ( page.lat && page.lng ) {
			mapCenter = {
				lat: parseFloat( page.lat ),
				lng: parseFloat( page.lng )
			}
		}

		return (
			<div className="section-event-details">
				<div className="-inner">
					{ eventDate &&
						<section className="event-date">
							<Editable
								id="set_event_date_time"
								element="div"
							>
								<p>
									{ eventHour }
									{ eventHour && <br /> }

									{ page.recur_text &&
										<span>
											{ page.recur_text }<br />
											{ translate( 'Next:' ) + ` ${eventDate}` }
										</span>
									||
										<span>
											{ eventDate }
										</span>
									}
								</p>
							</Editable>
						</section>
					}

					{ ( mapCenter || page.location || userCanEditPage ) &&
						<div className="map">
							{ mapCenter &&
								<Map
									defaultCenter={ mapCenter }
									lat={ mapCenter.lat }
									lng={ mapCenter.lng }
								/>
							}

							{ page.location &&
								<div className="p -location">
									<Editable
										id="event_location_label"
										element="div"
										content={ page.location_label }
									/>

									<Editable
										id="event_location"
										element="div"
										content={ page.location }
									/>
								</div>
							}

							{ userCanEditPage && ! mapCenter && ! page.location &&
								<div className="on-editor-open edit-set-custom-block">
									<Editable
										id="set_event_location"
										element="div"
									>
										<p>
											{ translate( 'Add location' ) }
										</p>
									</Editable>
								</div>
							}
						</div>
					}
				</div>
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	let selected = state.page.selected,
		// userCanEditPage = selected && selected.user_can_edit ? selected.user_can_edit : false
		userCanEditPage = siteData.current_user_can_edit_pages

	return {
		page: state.page.selected,
		userCanEditPage: userCanEditPage,
	}
}

export default localize(
	connect( mapStateToProps )( EventDetails )
)
